import type { ReactNode } from "react";

import { NavigationBar, type NavigationBarProps } from "./NavigationBar/NavigationBar";

import styles from "./AppLayout.module.scss";

interface Props extends NavigationBarProps {
  children: ReactNode,
}

export function AppLayout({ children, ...rest }: Props) {
  return (
    <>
      <NavigationBar {...rest} />
      <main className={styles.main}>
        {children}
      </main>
    </>
  );
}
